





























































import axios from 'axios'
import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Post, {IPost, PostStatus} from '@/models/Post'
import {DataTableHeader} from 'vuetify'
import ListCount from '@/components/admin/ListCount.vue'

@Component({
  components: {
    ListCount
  }
})
export default class Posts extends VueBase {
  @Prop(String) readonly path!: string
  @Prop({ type: Array, default: () => {
      return [
        { text: '', value: 'actions', sortable: false, width: 70 },
        { text: 'タイトル', value: 'title', width: 500 },
        { text: '公開日時', value: 'publishAtNumber', width: 180 },
        { text: '変更日時', value: 'updatedAtNumber', width: 180 },
        { text: 'SEOタイトル', value: 'seo_title', width: 300 },
        { text: 'SEOディスクリプション', value: 'seo_description', width: 300 }
      ]
  }}) readonly headers: Array<DataTableHeader>
  @Prop({ type: Function, default: (data: Array<IPost>): Array<Post> => {
      return data.map(m => new Post(m))
  }}) readonly toD!: (data: Array<IPost>) => Array<Post>
  posts: Array<Post> = []
  filterMode: PostStatus | 'all' = 'all'
  keyword = ''
  selected = []

  get viewPosts(): Array<Post> {
    switch (this.filterMode) {
      case 'publish': return this.publishedPosts
      case 'draft': return this.draftPosts
      case 'private': return this.privatePosts
    }
    return this.filteredPosts
  }

  get filteredPosts(): Array<Post> {
    if (this.keyword) {
      return this.posts.filter(
        post => post.title.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase())
      )
    }
    return this.posts
  }

  get publishedPosts(): Array<Post> {
    return this.filteredPosts.filter(p => p.status === 'publish')
  }

  get draftPosts(): Array<Post> {
    return this.filteredPosts.filter(p => p.status === 'draft')
  }

  get privatePosts(): Array<Post> {
    return this.filteredPosts.filter(p => p.status === 'private')
  }

  get apiIndexPath(): string {
    return `/api/v1/admin/${this.path}`
  }

  mounted(): void {
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const posts = await axios.get<Array<IPost>>(this.apiIndexPath)
      this.posts = this.toD(posts.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  destroy(): void {
    this.showConfirm({
      title: '削除', message: `選択した${this.selected.length}件を削除しますか？`, onClosed: async (result) => {
        if (result) {
          await axios.delete(this.apiIndexPath, {
            params: {
              id: this.selected.map(s => s.id)
            }
          })
          this.showMessage(`${this.selected.length}件の削除が完了しました`)
          this.selected = []
          this.reload()
        }
      }
    })
  }
}
